import * as d3Base from 'node_modules/d3/build/d3.node'
// Extend D3 with this 2 plugins
import { selectionMulti } from 'd3-selection-multi'
import { jetpack } from 'd3-jetpack'

// attach all d3 plugins to the d3 library
module.exports = Object.assign(d3Base, { selectionMulti, jetpack })



// WEBPACK FOOTER //
// ./src/utils/d3.js